import React, { useRef, useState } from 'react'
import { Dialog, Spinner, toaster } from 'evergreen-ui';
import {
  PageTitleText 
} from '../../../../../widget/styledComponents/headings.style';
import {
  FieldBtn
} from '../../security/security.style'
import {
  AppInputField,InputFieldTitleText,AppInputFieldBtn,AppInputFieldBtnCancel
} from '../../../../../widget/styledComponents/input_field.style'
import Cookies from 'js-cookie';
import { gql, useMutation } from '@apollo/client';
import ListBank from './list_bank';



export const ADD_BANK = gql`
mutation FacilityManager_addBankAccount($accountNumber: String!, $bankCode: String!) {
  facilityManager_addBankAccount(accountNumber: $accountNumber, bankCode: $bankCode) {
    code
    success
    error
    token
  }
}
`;






const AddBankButton = () => {
const accesTokenValue = Cookies.get('userAccessToken');
const [ addBank, {loading}] = useMutation(ADD_BANK);


  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

const handleSubmit = (e)=>{
  e.preventDefault()

  console.log(accountNumber.current.value)
  console.log(selectedBank)

  addBank({
    variables: { 
      accountNumber:accountNumber.current.value,
      bankCode: selectedBank,
    },
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  }).then((response) => {
    toaster.success("Bank added successfully.")
    window.location.reload();
  })
  .catch((error) => {
    console.log("sdd==",error);
    toaster.danger(error.message)

  });

}
const [selectedBank, setSelectedBank] = useState('');
const accountNumber = useRef(null);
const handleBankSelect = (value) => {
  console.log("Pickedede")
  console.log(value)
  setSelectedBank(value)
};



  return (
    <div>

      <FieldBtn onClick={handleOpenDialog} class="waves-effect waves-light btn-flat  ">
          <i class="material-icons left">add</i>
          Add New Bank
      </FieldBtn>
      <Dialog
        width="55%"
        isShown={isDialogOpen}
        title="Add New security"
        // onCloseComplete={() => setIsDialogOpen(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={false}
        hasHeader={false}
        hasFooter={false}
      >
        <form onSubmit={handleSubmit}>
        
        <div className='container'>
          <PageTitleText className='pl-16 pt-25'  style={{
                  color:"#4F46E5 !important",
                  padding:"16px !important"
              }}>
                Add New Bank
          </PageTitleText>
          <div className='row'>
              <div className='col s12 m12 l6 mt-25'>
                  <InputFieldTitleText>
                    Account Number
                  </InputFieldTitleText>
                  <AppInputField
                      type="text" 
                      placholder="alijames@gmail.com"
                      ref={accountNumber}
                  required/> 
              </div>
              <div className='col s12 m12 l6 mt-25'>
                <InputFieldTitleText>
                    Bank
                </InputFieldTitleText>
                <ListBank onSelect={handleBankSelect}/>
              </div>
          </div>
      </div>
        <div className='row'>
            <div className='col s12 right' style={{
                display:"flex",
                flexWrap:"wrap",
                justifyContent:"end"
            }}>
                
                <div className='' style={{
                    width:"100px",
                    padding:"16px "
                }}>
                    <AppInputFieldBtnCancel 
                    className='btn btn-flat center p-2'
                    style={{
                        background:"transparent !important"
                    }} 
                    onClick={() => setIsDialogOpen(false)}
                  >
                        Cancel
                    </AppInputFieldBtnCancel >
                </div>
                <div className='' style={{
                    width:"120px",
                    padding:"16px "
                }}>

                    <AppInputFieldBtn type='submit' className='' disabled={loading}>

                        {loading
                        ?<center> <Spinner/></center>
                        :'Add'}
                    </AppInputFieldBtn>
                </div>
            </div>
        </div>
      </form>

      </Dialog>
    </div>
  );
};

export default AddBankButton;
